import { formatTime } from "@/lib/audio-player-utils"

/**
 * The chip that names a hovered moment on a recording's clock. The waterfall
 * and the audio timeline both draw it, so a moment hovered on one reads the
 * same on the other.
 */
export const HOVER_TIME_LABEL_CLASS =
  "rounded bg-coval-contrast px-1 py-px font-mono text-[10px] tabular-nums whitespace-nowrap text-coval-text-on-contrast"

/**
 * A moment on the recording's clock as `MM:SS.t`, with tenths at every
 * length so a gap past the first minute still reads as about one second or
 * about two.
 */
export function formatHoverTime(seconds: number): string {
  const tenths = Number.isFinite(seconds)
    ? Math.max(0, Math.round(seconds * 10))
    : 0
  return `${formatTime(tenths / 10)}.${tenths % 10}`
}
